import { ref } from 'vue'
interface TaskData {
    title: string
    firstData:string
    secondData:string
  }
export default function taskSetting() {
  const followTask = ref<TaskData[]>()
  followTask.value = [
    {
      title: '有效销售线索（首次）',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '有效销售线索（循环）',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '潜在客户（谈判）',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '潜在客户（搁置）',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '签约客户（对接）',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '签约客户（暂停合作）',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '成交客户（1档）',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '成交客户（2档）',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '成交客户（3档）',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '成交客户（4档）',
      firstData: '80',
      secondData: '60'
    }
  ]
  const readyChangeTask = ref<TaskData[]>()
  readyChangeTask.value = [
    {
      title: '新线索',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '新潜在客户',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '新签约客户',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '新成交客户',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '老客户新商机额',
      firstData: '80',
      secondData: '60'
    }
  ]
  const otherTask = ref<TaskData[]>()
  otherTask.value = [
    {
      title: '未来线索跟进任务',
      firstData: '80',
      secondData: '60'
    },
    {
      title: '访客计划',
      firstData: '80',
      secondData: '60'
    }
  ]
  return { followTask, readyChangeTask, otherTask }
}
